export const advertising = {
  list: '广告列表',
  from: '广告操作',
  create: '添加广告',
  view: '查看广告',

  title: '广告标题',
  picture: '广告图片',
  type: '广告访问类型',
  params: '广告访问参数',
  duration: '持续时长',
  language: '广告语言',
  content: '广告详情',

  organization_info: '公司信息',
  organization_name: '公司名称',
  start_time: '开始时间',
  end_time: '结束时间',
  valid_status: '有效状态',

  rules: {
    location_id: {
      require: '广告位标题不能为空',
    },
    title: {
      require: '广告标题不能为空',
    },
    picture: {
      require: '广告图片不能为空',
    },
  },

  // 广告位
  position: {
    list: '广告位列表',
    from: '广告位操作',

    name: '广告位名称',
    title: '广告位标识',
    width: '广告位宽度',
    height: '广告位高度',
    is_open: '是否开启',

    rules: {
      name: {
        require: '广告位名称不能为空',
      },
      title: {
        require: '广告位标识不能为空',
      },
      width: {
        require: '广告位宽度不能为空',
      },
      height: {
        require: '广告位高度不能为空',
      },
    },
  },

  log: {
    info: '操作日志',

    user_info: '用户信息',

    params: '请求参数',
    content: '操作内容',
    create_time: '操作时间',
  },

  harbor: {
    ship_name: '船名',

    setting: '配置',
    top: '置顶',
  }
}
